import React from "react";
import Slider from "react-slick";
import torontoImg from "../../../images/dest-toronto.webp";
import vancouverImg from "../../../images/dest-vancouver.webp";
import laImg from "../../../images/dest-la.webp";
import miamiImg from "../../../images/dest-miami.webp";
import orlando from "../../../images/dest-orlando.webp";
import calgary from "../../../images/dest-calgary.webp";
// import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { registerSearch } from "../../../api/services/carService";
import { navigateToSearchResults } from "../../../utils/urlParams";
import { useCurrency } from "../../../context/CurrencyContext";
import { useFormContext } from "../../../context/FormContext";

const locations = [
  {
    city: "Toronto",
    country: "Canada",
    price: "$31",
    image: torontoImg,
    searchParams: {
      pickup: "Toronto International Airport (YYZ), Canada",
      dropoff: "Toronto International Airport (YYZ), Canada",
      pickupCode: "691ae7d3c263b38fd56c9fa0",
      dropoffCode: "691ae7d3c263b38fd56c9fa0",
      sameLocation: "true",
      country: "CA",
      age: "26-70",
    },
  },
  {
    city: "Vancouver",
    country: "Canada",
    price: "$35",
    image: vancouverImg,
    searchParams: {
      pickup: "Vancouver International Airport (YVR), Canada",
      dropoff: "Vancouver International Airport (YVR), Canada",
      pickupCode: "69e09be4a23a981d07aefeb6",
      dropoffCode: "69e09be4a23a981d07aefeb6",
      sameLocation: "true",
      country: "CA",
      age: "26-70",
    },
  },
  {
    city: "Los Angeles",
    country: "USA",
    price: "$29",
    image: laImg,
    searchParams: {
      pickup: "Los Angeles International Airport (LAX), United States",
      dropoff: "Los Angeles International Airport (LAX), United States",
      pickupCode: "6a213b18f6f33934e067d527",
      dropoffCode: "6a213b18f6f33934e067d527",
      sameLocation: "true",
      country: "US",
      age: "26-70",
    },
  },
  {
    city: "Miami",
    country: "USA",
    price: "$33",
    image: miamiImg,
    searchParams: {
      pickup: "Miami International Airport (MIA), United States",
      dropoff: "Miami International Airport (MIA), United States",
      pickupCode: "6a2009d621fbb956f109f144",
      dropoffCode: "6a2009d621fbb956f109f144",
      sameLocation: "true",
      country: "US",
      age: "26-70",
    },
  },
  {
    city: "Orlando",
    country: "USA",
    price: "$27",
    image: orlando,
    searchParams: {
      pickup: "Orlando International Airport (MCO), United States",
      dropoff: "Orlando International Airport (MCO), United States",
      pickupCode: "69e09b7da23a981d07aefeb5",
      dropoffCode: "69e09b7da23a981d07aefeb5",
      sameLocation: "true",
      country: "US",
      age: "26-70",
    },
  },
  {
    city: "Calgary",
    country: "Canada",
    price: "$30",
    image: calgary,
    searchParams: {
      pickup: "Calgary International Airport (YYC), Canada",
      dropoff: "Calgary International Airport (YYC), Canada",
      pickupCode: "691aec88c263b38fd56c9fa1",
      dropoffCode: "691aec88c263b38fd56c9fa1",
      sameLocation: "true",
      country: "US",
      age: "26-70",
    },
  },
];

// const buildSearchUrl = (searchParams) => {
//   if (!searchParams) return null;

//   const today = new Date();

//   const pickupDate = new Date(today);
//   pickupDate.setDate(today.getDate() + 8);

//   const dropoffDate = new Date(today);
//   dropoffDate.setDate(today.getDate() + 13);

//   const fmt = (date) => date.toISOString().split("T")[0];

//   const params = new URLSearchParams({
//     ...searchParams,
//     pickupDate: fmt(pickupDate),
//     pickupTime: "10:00",
//     dropoffDate: fmt(dropoffDate),
//     dropoffTime: "10:00",
//   });

//   const queryString = params.toString();
//   // console.log("Generated URL:", queryString);
//   return queryString;

//   // return `/results?${params.toString()}`;
// };

const News = () => {

  const navigate = useNavigate();
  const { selectedCurrency } = useCurrency();

  const handleDestinationClick = async (location) => {
    const today = new Date();

    const pickupDate = new Date(today);
    pickupDate.setDate(today.getDate() + 8);

    const dropoffDate = new Date(today);
    dropoffDate.setDate(today.getDate() + 13);

    const fmt = (date) => date.toISOString().split("T")[0];

    const registerPayload = {
      pickup_location_id: location.searchParams.pickupCode,
      dropoff_location_id: location.searchParams.dropoffCode,
      pickup_location_name: location.searchParams.pickup,
      dropoff_location_name: location.searchParams.dropoff,
      pickup_datetime: `${fmt(pickupDate)}T10:00:00`,
      dropoff_datetime: `${fmt(dropoffDate)}T10:00:00`,
      age: 35,
      residence: location.searchParams.country,
      currency: selectedCurrency?.code || "USD",
      is_test: false,
    };

    try {
      const registerResponse = await registerSearch(registerPayload);
      const searchId = registerResponse?.search_id;

      if (!searchId) {
        console.error("registerSearch did not return a search_id");
        return;
      }

      // Save location names for summary bar
      localStorage.setItem(
        "pickup_location_name",
        location.searchParams.pickup,
      );
      localStorage.setItem(
        "dropoff_location_name",
        location.searchParams.dropoff,
      );
      sessionStorage.setItem("search_pickupDate", fmt(pickupDate));
      sessionStorage.setItem("search_dropoffDate", fmt(dropoffDate));
      sessionStorage.setItem("search_pickupTime", "10:00");
      sessionStorage.setItem("search_dropoffTime", "10:00");
      sessionStorage.setItem("search_driverAge", "35");
      sessionStorage.setItem(
        "search_driverCountry",
        location.searchParams.country,
      );
      sessionStorage.setItem("returningFromSearch", "true");
      localStorage.setItem("is_own_search", "true");
      localStorage.removeItem("search_id_currency");

      // Pre-fill FormContext so summary bar shows immediately
      setPickup(location.searchParams.pickup);
      setDropoff(location.searchParams.dropoff);
      setPickupGDSCode(location.searchParams.pickupCode);
      setDropOffGDSCode(location.searchParams.dropoffCode);
      setPickupDate(fmt(pickupDate));
      setDropoffDate(fmt(dropoffDate));
      setPickupTime("10:00");
      setDropoffTime("10:00");
      setDriverCountry(location.searchParams.country);
      setDriverAge("35");

      navigateToSearchResults(navigate, searchId);
    } catch (e) {
      console.error("Error registering search from destination card:", e);
    }
  };

  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 4 } },
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1.2 } },
    ],
  };

  const {
    setPickup,
    setDropoff,
    setPickupGDSCode,
    setDropOffGDSCode,
    setPickupDate,
    setDropoffDate,
    setPickupTime,
    setDropoffTime,
    setDriverCountry,
    setDriverAge,
  } = useFormContext();

  return (
    <div className="max-w-7xl mx-auto px-4 py-10 bg-white font-sans selection:bg-emerald-100">
      <style>{`
        .slick-track { display: flex !important; }
        .slick-slide { height: auto !important; }
        .slick-slide > div { height: 100%; }
      `}</style>

      {/* Header — "View all" removed */}
      <div className="flex justify-between items-end mb-5 px-1">
        <h2 className="text-[20px] md:text-[32px] font-bold tracking-tight text-[#0f172a] leading-[1.2]">
          Popular Destinations
        </h2>
      </div>

      {/* Card Carousel */}
      <div className="mx-[-6px]">
        <Slider {...settings}>
          {locations.map((location, index) => {
            // const url = buildSearchUrl(location.searchParams);
            const cardContent = (
              <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden h-full flex flex-col transition-all duration-200">
                {/* Image */}
                <div className="h-[145px] w-full overflow-hidden flex-shrink-0">
                  <img
                    src={location.image}
                    alt={location.city}
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Info */}
                <div className="p-4 flex flex-col flex-grow">
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-[15px] font-semibold text-[#0f172a]">
                      {location.city}
                    </h3>
                    <div className="text-[12px] text-gray-400">
                      From{" "}
                      <span className="text-[#22c55e] font-semibold text-[14px]">
                        {location.price}/day
                      </span>
                    </div>
                  </div>

                  <div className="mt-auto">
                    <div className="border-t border-gray-200 mb-3.5"></div>
                    <div className="flex items-center gap-1.5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-[15px] w-[15px] text-[#22c55e]/90"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={1.8}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                      <span className="text-[12px] font-body text-xs text-text-muted mt-0.5">
                        {location.country}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );

            return (
              <div key={index} className="px-1.5 h-full">
                <div
                  onClick={() => handleDestinationClick(location)}
                  className="block h-full hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 rounded-2xl cursor-pointer"
                >
                  {cardContent}
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default News;